import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useGetUsersWithoutRoleQuery, useSetLibraryAdminMutation } from '../../../generated/graphql';
import { FormAutoComplete } from '../../form';
import styles from './NewLibraryAdminDialog.module.css';

type NewLibraryAdminDialogProps = {
    onClose: () => void,
    libraryId: string,
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const NewLibraryAdminDialog = (props: NewLibraryAdminDialogProps) => {
    const { style, visible, libraryId, onClose } = props;
    const [searchUser, setSearchUser] = useState('');
    const [setLibraryAdmin, setLibraryAdminResult] = useSetLibraryAdminMutation();
    const [validationError, setValidationError] = useState('');
    const users = useGetUsersWithoutRoleQuery({
        variables: { contains: searchUser }
    });

    const handleSubmit = () => {
        const selectedEmail = users.data?.UserList?.nodes?.filter(u => u?.email === searchUser)[0];
        if (!searchUser) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        if (!selectedEmail) {
            setValidationError('Please Select A Valid Email!');
            return;
        }
        setValidationError('');
        setLibraryAdmin({
            variables: { id: libraryId, userId: selectedEmail?.id }
        })
            .then(() => onClose())
            .catch(() => {});
    };

    return (
        <DialogBase
            title="New Library Admin"
            type="OkCancel"
            isLoading={setLibraryAdminResult.loading}
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            className={styles.NewLibraryAdminDialog}
            style={style}
            data-testid="NewClientAdminDialog">
            <FormAutoComplete
                label="Email"
                name="email"
                value={searchUser}
                onChange={setSearchUser}
                options={(users.data?.UserList?.nodes?.map(c => c?.email) || []).filter((e): e is string => !!e)}
            />
        </DialogBase>
    );
};

export default NewLibraryAdminDialog;